import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';
import { AppProps } from './App';

const getInitialState: GetInitialStateInner<AppProps> = ({
  course,
  country_prefix: countryPrefix,
  LANGUAGE_KEY,
  metaTags,
  innerWidth,
  queryParams,
  buildYourBundleData,
  featureFlags,
  isCouponCampaign,
  is_course_for_ab_test: isCourseForAbTest,
}) => {
  return {
    course: {
      ...course,
      attachmentSet: course.attachmentSet
        ? course.attachmentSet.edges.map(attachment => attachment.node)
        : [],
      loading: false,
      loadingFollow: false,
      isLive: false,
      timerStyle: 'normal',
      backgroundColor: '#4b22f4' || course.backgroundColor || '#7CFBFF',
    },
    countryPrefix,
    userLanguage: LANGUAGE_KEY,
    metaTags,
    innerWidth,
    queryParams,
    buildYourBundleData,
    canShowMembershipFeature:
      countryPrefix === 'co' &&
      Boolean(
        featureFlags.find(f => {
          return f.key === 'course_detail_membership';
        }),
      ),
    isCouponCampaign,
    isCourseForAbTest,
  };
};

export default getInitialState;
